// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__46+J9","button":"ChangePassword_button__3CRLD"};